import React, { useState } from 'react';


const ChartSettingPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showChartSettingPopup,setshowChartSettingPopup] = useState<boolean>(false);

    const chartSettingToggleHandler = () => {
        setshowChartSettingPopup(!showChartSettingPopup);
    }
	
	return <Component showChartSettingPopup={showChartSettingPopup} chartSettingToggleHandler={chartSettingToggleHandler} {...props}/>;
};

export default ChartSettingPopupHOC;   